<div class="cosmos-date-picker">
  <mat-datepicker-toggle
    [for]="picker"
    class="cosmos-date-picker__toggle"
    matSuffix
  ></mat-datepicker-toggle>
  <input
    [matDatepicker]="picker"
    [readonly]="true"
    placeholder="Subscription Expiration (YYYY-MM-DD)"
    class="cosmos-date-picker__input"
  >
</div>
<mat-datepicker #picker></mat-datepicker>
